import React from 'react';

const CartSummary = ({ subtotal, onCheckout, cartItems = [] }) => {
  const shipping = subtotal > 100 ? 0 : 10;
  const tax = subtotal * 0.08;
  const total = subtotal + shipping + tax;

  return (
    <div className="bg-gray-50 p-6">
      <h2 className="text-sm font-light tracking-wide uppercase text-gray-400 mb-5">
        Order Summary
      </h2>
      
      {/* Mini Cart Items Preview */}
      {cartItems.length > 0 && (
        <div className="mb-5 pb-4 border-b border-gray-200 max-h-48 overflow-y-auto">
          <p className="text-xs text-gray-400 mb-3">Items in cart</p>
          {cartItems.map((item, idx) => (
            <div key={idx} className="flex gap-3 mb-3 last:mb-0">
              <div className="w-10 h-12 bg-gray-100 flex-shrink-0">
                {/* Image would go here - keeping minimal */}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-gray-700 truncate">{item.title}</p>
                <p className="text-xs text-gray-400 mt-0.5">Qty: {item.quantity}</p>
              </div>
              <p className="text-xs text-gray-900 whitespace-nowrap">
                ${(item.price * item.quantity).toFixed(2)}
              </p>
            </div>
          ))}
        </div>
      )}
      
      <div className="space-y-3 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-500">Subtotal</span>
          <span className="text-gray-900">${subtotal.toFixed(2)}</span>
        </div>
        
        <div className="flex justify-between">
          <span className="text-gray-500">Shipping</span>
          <span className="text-gray-900">
            {shipping === 0 ? 'Free' : `$${shipping.toFixed(2)}`}
          </span>
        </div>
        
        <div className="flex justify-between">
          <span className="text-gray-500">Tax (8%)</span>
          <span className="text-gray-900">${tax.toFixed(2)}</span>
        </div>
        
        <div className="border-t border-gray-200 pt-3 mt-3">
          <div className="flex justify-between">
            <span className="text-sm font-medium text-gray-900">Total</span>
            <span className="text-base font-medium text-gray-900">${total.toFixed(2)}</span>
          </div>
        </div>
      </div>

      <button
        onClick={onCheckout}
        className="w-full mt-6 py-3 text-sm font-medium tracking-wide text-white bg-gray-900 hover:bg-gray-800 transition"
      >
        Proceed to Checkout
      </button>

      <div className="mt-4 text-center">
        <p className="text-xs text-gray-400">
          Free shipping on orders over $100
        </p>
      </div>
    </div>
  );
};

export default CartSummary;